/**
 * Centralized react-query key registry.
 * Keys are typed arrays so structural comparison works correctly.
 */

export const queryKeys = {
  // Broker
  walletBalance: () => ['walletBalance'] as const,
  walletTransactions: (params: { page: number; limit: number }) =>
    ['walletTransactions', params] as const,

  // Admin — settings
  adminSettings: () => ['adminSettings'] as const,

  // Admin — accounts
  adminAccounts: (params: {
    role?: string;
    page: number;
    limit: number;
    includeInactive?: boolean;
  }) => ['adminAccounts', params] as const,
  adminAccount: (id: string | null) => ['adminAccount', id] as const,

  // Admin — deals
  adminDeals: (params: Record<string, unknown>) => ['adminDeals', params] as const,
  adminDeal: (id: string | null) => ['adminDeal', id] as const,
  adminDealActivity: (id: string | null) => ['adminDealActivity', id] as const,

  // Admin — brokers
  adminBrokers: (params: Record<string, unknown>) => ['adminBrokers', params] as const,
  adminBroker: (id: string | null) => ['adminBroker', id] as const,
  adminBrokerDeals: (id: string | null) => ['adminBrokerDeals', id] as const,
  adminBrokerActivityLog: (id: string | null, params: { page: number; limit: number }) =>
    ['adminBrokerActivityLog', id, params] as const,
  adminBrokerNotes: (id: string | null) => ['adminBrokerNotes', id] as const,

  // Admin — commission reports
  adminCommissionReports: (params: Record<string, unknown>) =>
    ['adminCommissionReports', params] as const,

  // Admin — system logs
  adminSystemLogs: (params: Record<string, unknown>) => ['adminSystemLogs', params] as const,

  // Admin — roles/permissions
  adminRoles: () => ['adminRoles'] as const,
  adminPermissionLogs: () => ['adminPermissionLogs'] as const,

  // Admin — overview
  adminOverview: (params: Record<string, unknown>) => ['adminOverview', params] as const,

  // Auth
  authMe: () => ['authMe'] as const,
  nafathInitiate: (refetchKey: number) => ['nafathInitiate', refetchKey] as const,

  // Broker — profile + transactions
  brokerProfile: () => ['brokerProfile'] as const,
  brokerTransaction: (id: string | null) => ['brokerTransaction', id] as const,
  brokerTransactions: (params: Record<string, unknown>) => ['brokerTransactions', params] as const,

  // Payer
  payerDeal: (id: string | null) => ['payerDeal', id] as const,

  // Geo
  saudiRegions: () => ['saudiRegions'] as const,
  saudiCities: (regionId: string | null) => ['saudiCities', regionId] as const,
  saudiDistricts: (cityId: string | null) => ['saudiDistricts', cityId] as const,
} as const;
